module.exports = __webpack_public_path__ + "static/media/HP_rightopps_city.bb761ee0.jpg";